import React, { useRef,  useState } from 'react';
import { motion } from 'framer-motion';
const ImgHoverEffect = ({ children, className = '', intensity = 20, scale = 1.05 }) => {
    const containerRef = useRef(null);
    const [rotate, setRotate] = useState({ x: 0, y: 0 });
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseMove = (e) => {
        if (!containerRef.current) return;
        
        const rect = containerRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const rotateX = (y - centerY) / intensity;
        const rotateY = (centerX - x) / intensity;
        
        setRotate({ x: rotateX, y: rotateY });
    };

    return (
        <motion.div
            initial={{opacity: 0}}
            whileInView={{opacity: 1}}
            transition={{duration: 0.5}}
            viewport={{once: true}} 
            ref={containerRef}
            className={`img-hover-container ${className}`}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => {
                setIsHovered(false);
                setRotate({ x: 0, y: 0 });
            }}
            style={{
                display: 'inline-block',
                perspective: '1000px',
                transformStyle: 'preserve-3d',
            }}
        >
            <div 
                style={{
                    transform: `rotateX(${rotate.x}deg) rotateY(${rotate.y}deg) scale(${isHovered ? scale : 1})`,
                    transition: 'transform 0.3s ease-out',
                    transformStyle: 'preserve-3d',
                    willChange: 'transform',
                    height: '100%',
                    width: '100%'
                }}
            >
                {children}
            </div>
        </motion.div>
    );
};

export default ImgHoverEffect;
